import { render } from "./LeadingTrailingField.vue?vue&type=template&id=76318841"
import script from "./LeadingTrailingField.vue?vue&type=script&lang=js"
export * from "./LeadingTrailingField.vue?vue&type=script&lang=js"
script.render = render

export default script